import React from 'react';

// CB:BEGIN email-preview-out-of-scope
const EmailOutOfScope: React.FC = () => {
  const address = "123 Rosewood Way, O'Fallon, MO 63366";
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#6b7280', padding: 20, borderRadius: 8, marginBottom: 20, textAlign: 'center' }}>
        <h2 style={{ color: 'white', margin: 0 }}>ℹ️ Project Out of Scope</h2>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Thank you for your interest in CoreBids. We appreciate you considering us for your roofing project.
      </p>
      <div style={{ background: '#f3f4f6', padding: 15, borderRadius: 6, margin: '20px 0', borderLeft: '4px solid #6b7280' }}>
        <p style={{ fontSize: 16, fontWeight: 600, margin: 0, color: '#1f2937' }}>
          <strong>Property Address:</strong> {address}
        </p>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Unfortunately, partial roof replacement projects are currently outside our scope of service. We focus on full roof replacements to ensure quality, consistency, and long-term durability.
      </p>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <strong>Why we focus on full replacements:</strong>
      </p>
      <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <li>Better warranty coverage and protection</li>
        <li>Consistent material quality and appearance</li>
        <li>Improved energy efficiency and insulation</li>
        <li>Longer lifespan and reduced maintenance</li>
      </ul>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        If you'd like to discuss a full roof replacement for your property, or if you have any questions about our services, please don't hesitate to reach out through your dashboard.
      </p>
      <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '30px 0' }} />
      <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        From: CoreBids Notifications &lt;notifications@corebids.com&gt;<br />
        This mailbox isn't monitored. Please don't reply. Contact support via your dashboard.
      </p>
    </div>
  );
};

export default EmailOutOfScope;
// CB:END email-preview-out-of-scope


